{
    "a_durable_record_of_successful_claim_actions_and_outcomes": "A durable record of successful claim actions and outcomes.",
    "a_short_interval_alone_does_not_establish_a_claim_violation": ". A short interval alone does not establish a claim violation.",
    "active_denial_risks": "Active denial risks",
    "active_risks_one": "{{count}} active denial risk",
    "active_risks_other": "{{count}} active denial risks",
    "add_note": "Add note",
    "all_claims": "All claims",
    "all_findings_have_a_recorded_decision_confirmed_denial_risks_remain_active": "All findings have a recorded decision. Confirmed denial risks remain active.",
    "all_review_checks_have_been_resolved": "All review checks have been resolved.",
    "back_to_claims": " Back to claims",
    "bpjs_claim_field_reviewed": "BPJS claim field reviewed.",
    "bpjs_claim_fields_saved": "BPJS claim fields saved.",
    "bpjs_claim_unavailable": "BPJS claim unavailable",
    "bpjs_claims_could_not_be_loaded": "BPJS claims could not be loaded.",
    "bpjs_hospital_guidance_disabled": "BPJS hospital guidance disabled",
    "cancel": "Cancel",
    "chat_will_be_available_when_document_text_processing_finishes": "Chat will be available when document text processing finishes.",
    "check_exceptions": "Check exceptions:",
    "check_the_evidence_then_record_whether_each_finding_is_correct": "Check the evidence, then record whether each finding is correct.",
    "check_the_source_then_close_this_preview_to_return_to_your_finding": "Check the source, then close this preview to return to your finding.",
    "claim_cancelled": "Claim cancelled",
    "claim_document": "Claim document",
    "claim_fields": "Claim fields",
    "claim_history": "Claim history",
    "claim_history_could_not_be_loaded": "Claim history could not be loaded.",
    "claim_moved": "Claim moved.",
    "claim_moved_2": "Claim moved",
    "claim_renamed": "Claim renamed.",
    "claim_renamed_2": "Claim renamed",
    "claim_review_steps": "Claim review steps",
    "claim_workspace": "Claim workspace",
    "claims": "Claims",
    "claims_unavailable": "Claims unavailable",
    "clarification_needed": "Clarification needed:",
    "clear_document_search": "Clear document search",
    "clear_finding_search": "Clear finding search",
    "clinical_support_details": "Clinical support details",
    "complete": "Complete",
    "concurrent_field_changes": "Concurrent field changes",
    "confirm_reviewed_fields": "Confirm reviewed fields",
    "consistency_scope": "Consistency scope",
    "content": ". Content:",
    "correctly_flagged": "Correctly flagged",
    "could_not_save_this_verification_refresh_the_claim_and_check_that_the": "Could not save this verification. Refresh the claim and check that the review is current.",
    "coverage_is_unavailable_re_run_the_review_to_assess_every_documented_diagnosis": "Coverage is unavailable. Re-run the review to assess every documented diagnosis, procedure and document check.",
    "coverage_labels": {
        "confirmed_in_reviewed_fields": "Signature recorded in confirmed fields",
        "contradicted": "Conflicting evidence",
        "image_review_required": "Inspect the signature on the page",
        "insufficient_evidence": "Needs clarification",
        "not_applicable": "Not applicable",
        "not_assessed": "Not assessed",
        "supported": "Supported",
        "unreadable": "Image review needed"
    },
    "days_before_this_admission_principal_diagnosis": " days before this admission. Principal diagnosis:",
    "decision_saved_confirmed_findings_remain_active": "Decision saved. Confirmed findings remain active.",
    "decision_saved_this_finding_is_in_dismissed": "Decision saved. This finding is in Dismissed.",
    "decisions_recorded_denial_risks_remain": "Decisions recorded; denial risks remain",
    "denial_risks": "Denial risks",
    "diagnosis": "Diagnosis:",
    "diagnosis_and_procedure_evidence": "Diagnosis and procedure evidence",
    "disable": "Disable",
    "disable_guidance": "Disable guidance",
    "disable_this_bpjs_guidance": "Disable this BPJS guidance?",
    "document_number": "Document {{number}}",
    "document_text_processing_failed_retry_ocr_before_sending_a_message": "Document text processing failed. Retry OCR before sending a message.",
    "documented_exception": "Documented exception: ",
    "documented_in_clinical_record_only": "Documented in clinical record only",
    "documented_items_assessed": " documented items assessed.",
    "earlier_review_method": "Earlier review method",
    "edit_note": "Edit note",
    "errors": {
        "forbidden": "You do not have permission to perform this action.",
        "not_found": "This claim or resource is no longer available. Refresh and try again.",
        "request_failed": "The request could not be completed. Please try again.",
        "validation": "Check the entered values and try again."
    },
    "evidence_source_and_page_or_record": "Evidence source and page or record",
    "explain_why_this_finding_does_not_apply_to_this_claim": "Explain why this finding does not apply to this claim.",
    "field_extraction_failed": "Field extraction failed. Please try again.",
    "field_review_is_optional_bpjs_risks_use_the_uploaded_pdf_and_do": "Field review is optional. BPJS risks use the uploaded PDF and do not change when you edit these fields.",
    "fields_optional": "Fields (optional)",
    "filter_findings": "Filter findings",
    "filtered_count": "Filtered count",
    "finding_filters": {
        "active": "All active",
        "dismissed": "Dismissed",
        "reviewed": "Reviewed",
        "unreviewed": "Needs decision"
    },
    "finding_priority": {
        "high": "high priority",
        "low": "low priority",
        "moderate": "moderate priority"
    },
    "finding_reopened_for_review": "Finding reopened for review.",
    "findings_shown": "{{shown}} of {{total}} findings shown. Unreviewed findings first, then highest priority.",
    "flagged_in_error": "Flagged in error",
    "folder_cannot_be_deleted_while_it_contains_claims": "Folder cannot be deleted while it contains claims",
    "folder_choices_could_not_be_loaded": "Folder choices could not be loaded.",
    "folder_choices_could_not_be_loaded_retry_before_moving_this_claim": "Folder choices could not be loaded. Retry before moving this claim.",
    "folder_deleted": "Folder deleted",
    "folder_items_one": "{{count}} item in this folder",
    "folder_items_other": "{{count}} items in this folder",
    "folder_removed": "Folder removed",
    "folder_renamed": "Folder renamed",
    "folders_metadata": "Folders and metadata",
    "folders_unavailable": "Folders unavailable",
    "fullscreen": "Fullscreen",
    "further_review_is_needed": "Further review is needed.",
    "guidance_saved_from_prior_dismissals_that_can_suppress_matching_false_positive_findings": "Guidance saved from prior dismissals that can suppress matching false-positive findings in future BPJS reviews.",
    "history": "History",
    "history_actions": {
        "claim_cancelled": "Claim cancelled",
        "claim_created": "Claim created",
        "claim_updated": "Claim updated",
        "export_generated": "Export generated",
        "extraction_completed": "Extraction completed",
        "fields_updated": "Fields updated",
        "forms_generated": "Forms generated",
        "review_coverage_verified": "Review coverage verified",
        "risk_confirmed": "Risk confirmed",
        "risk_dismissed": "Risk dismissed",
        "risk_dismissed_and_guidance_saved": "Risk dismissed and guidance saved",
        "risk_legacy_dismissal": "Risk dismissed (earlier review)",
        "risk_note_updated": "Risk note updated",
        "risk_reopened": "Risk reopened",
        "risk_review_completed": "Risk review completed",
        "risk_review_failed": "Risk review failed",
        "risk_review_started": "Risk review started",
        "submission_archived": "Submission archived",
        "submission_confirmed": "Submission confirmed",
        "submission_created": "Submission created",
        "submission_field_deleted": "Submission field deleted",
        "submission_field_updated": "Submission field updated",
        "submission_updated": "Submission updated",
        "submissions_reordered": "Submissions reordered"
    },
    "history_actor": {
        "agent": "agent",
        "system": "system",
        "user": "user"
    },
    "history_origin": {
        "automation": "automation",
        "bulk": "bulk",
        "chat": "chat",
        "manual_ui": "manual ui"
    },
    "hospital_guidance": "Hospital guidance",
    "how_folders_work": "How folders work",
    "how_the_evidence_resolves_this_check": "How the evidence resolves this check",
    "i_checked_complete_prior_30_day_admission_history_for_this_patient_and": "I checked complete prior 30-day admission history for this patient and facility, the principal diagnoses, and every candidate episode shown above.",
    "image_inspection": "Image inspection:",
    "invalid_json_array": "Invalid JSON array.",
    "it_will_no_longer_suppress_matching_findings_in_new_bpjs_claim_reviews": "It will no longer suppress matching findings in new BPJS claim reviews. Existing review results will not change.",
    "keep_a_note_with_this_claim_review": "Keep a note with this claim review.",
    "keep_editing": "Keep editing",
    "leave_page": "Leave page",
    "leave_without_saving": "Leave without saving?",
    "legacy_finding_notice": "This finding was saved in English. Run a new review to generate a Bahasa Indonesia version.",
    "listed_in_submitted_claim": "Listed in submitted claim",
    "loading_bpjs_claim": " Loading BPJS claim",
    "loading_claim_history": "Loading claim history…",
    "loading_guidance": " Loading guidance",
    "management_and_significance": "Management and significance:",
    "manifestations_and_attribution": "Manifestations and attribution:",
    "matching_page_position": "{{current}} of {{total}} matching pages",
    "more_claim_actions": "More claim actions",
    "move": "Move",
    "needs_decision": "Needs decision",
    "new_folder": "New folder",
    "new_folders_start_empty_move_a_claim_into_this_folder_or_upload": "New folders start empty. Move a claim into this folder or upload a new claim here.",
    "next_matching_page": "Next matching page",
    "next_step": "Next step:",
    "no_active_denial_risks_were_identified": "No active denial risks were identified.",
    "no_active_hospital_guidance_has_been_saved": " No active hospital guidance has been saved.",
    "no_findings_in_this_view": "No findings in this view",
    "no_findings_match_your_search": "No findings match your search",
    "no_history_is_available_yet": "No history is available yet.",
    "no_matching_pages": "No matching pages",
    "no_page_reference_supplied_check_the_source_packet": "No page reference supplied. Check the source packet.",
    "no_qualifying_readmission_after_verification": "No qualifying readmission after verification",
    "no_reimbursement_opportunities_were_identified": "No reimbursement opportunities were identified.",
    "no_supporting_excerpts_were_supplied_check_the_source_packet_before_deciding": "No supporting excerpts were supplied. Check the source packet before deciding.",
    "not_complete": "Not complete",
    "note": "Note",
    "of": "of ",
    "open": "Open",
    "open_source_pdf": "Open source PDF",
    "optional_does_not_change_risks": "Optional · Does not change risks",
    "optional_opportunities": "Optional opportunities",
    "optional_opportunities_to_review_these_do_not_prevent_completion_of_risk_review": "Optional opportunities to review. These do not prevent completion of risk review.",
    "page_number": "Page {{page}}",
    "page_unavailable": "Page {{page}} — source unavailable",
    "pages": ". Pages:",
    "policy_scope": "Policy scope",
    "presence": "Presence: ",
    "previous_matching_page": "Previous matching page",
    "previous_review_findings": "Previous review findings",
    "prior_admission_comparison": "Prior-admission comparison",
    "prior_stay": "Prior stay: ",
    "re_run_risks_to_review_the_uploaded_pdf_with_the_current_document": "Re-run Risks to review the uploaded PDF with the current document review.",
    "readmission_conclusion": "Readmission conclusion",
    "reason_to_reopen": "Reason to reopen",
    "record_the_evidence_that_supports_the_current_claim_if_coding_or_documents": "Record the evidence that supports the current claim. If coding or documents must change, update Review Data and re-run the review first.",
    "record_why_this_check_needs_further_review": "Record why this check needs further review.",
    "recorded_details": "Recorded details",
    "reduces_false_flags": "Reduces false flags",
    "reimbursement_opportunities": "Reimbursement opportunities",
    "rename_claim": "Rename claim",
    "reopen": "Reopen",
    "reopen_check": "Reopen check",
    "reopen_this_check": "Reopen this check",
    "repeated_documentation_of_a_submitted_item": "Repeated documentation of a submitted item",
    "rerun_risks": "Re-run Risks",
    "resolve_review_checks": "Resolve review checks",
    "retry": "Retry",
    "retry_risks": "Retry Risks",
    "review_coverage": "Review coverage",
    "review_denial_risks_check_the_source_documents_and_record_decisions_for_your": "Review denial risks, check the source documents, and record decisions for your BPJS claims.",
    "review_findings": "Review findings",
    "review_note": "Review note",
    "review_summary": "Review summary",
    "review_the_uploaded_pdf": "Review the uploaded PDF",
    "review_them_before_saving": ". Review them before saving.",
    "reviewed": "Reviewed",
    "reviewing_claim_documents_for_bpjs_risks_and_reimbursement_opportunities": "Reviewing claim documents for BPJS risks and reimbursement opportunities",
    "revision": "Revision",
    "risk_review_failed": "BPJS risk review failed. Retry the review.",
    "risk_review_starts_automatically_from_the_uploaded_pdf_you_can_review_optional": "Risk review starts automatically from the uploaded PDF. You can review optional extracted fields while you wait.",
    "risks": "Risks",
    "risks_needing_a_decision": "Risks needing a decision",
    "run_risks": "Run Risks",
    "save": "Save",
    "save_verification": "Save verification",
    "saved_by": "Saved by ",
    "saved_reviewer_verifications": "Saved reviewer verifications",
    "screening_results_and_agreement_with_a_finding_do_not_confirm_that_corrections": "Screening results and agreement with a finding do not confirm that corrections were made or that BPJS accepted the submission.",
    "search_document_text": "Search document text",
    "search_document_text_2": "Search document text…",
    "search_findings": "Search findings",
    "search_findings_evidence_or_notes": "Search findings, evidence or notes…",
    "server_values_changed_while_you_were_editing_your_local_values_were_kept": "Server values changed while you were editing. Your local values were kept for",
    "show_all_active_findings": "Show all active findings",
    "signature": "Signature:",
    "signer_relationship": ". Signer relationship:",
    "source_evidence": "Source evidence",
    "source_pdf": "Source PDF",
    "source_pdf_page": "Source PDF · Page ",
    "source_pdf_unavailable_refresh_the_claim_to_try_again": "Source PDF unavailable. Refresh the claim to try again.",
    "submission_status_needs_confirmation": "Submission status needs confirmation",
    "supporting_documents_and_delivery": "Supporting documents and delivery",
    "supporting_evidence": "Supporting evidence",
    "team_member": "Team member",
    "the_change_could_not_be_saved_refresh_the_claim_and_try_again": "The change could not be saved. Refresh the claim and try again.",
    "the_claim_changed_or_could_not_be_saved_server_changes_were_refreshed": "The claim changed or could not be saved. Server changes were refreshed and your local edits were kept.",
    "the_claim_changed_the_latest_reviewer_state_was_refreshed_please_try_again": "The claim changed. The latest reviewer state was refreshed; please try again.",
    "the_claim_could_not_be_loaded_refresh_the_page_or_return_to": "The claim could not be loaded. Refresh the page or return to the claims list.",
    "the_confirmed_issues_still_need_attention_in_the_claim_documents_before_submission": "The confirmed issues still need attention in the claim documents before submission.",
    "the_note_could_not_be_saved_your_text_is_still_here_check": "The note could not be saved. Your text is still here; check the latest claim state and try again.",
    "these_findings_are_from_the_previous_completed_review_the_current_review_has": "These findings are from the previous completed review. The current review has not completed.",
    "this_denial_risk_remains_active_confirming_a_flag_records_your_assessment_it": "This denial risk remains active. Confirming a flag records your assessment; it does not resolve the issue in the claim.",
    "to": " to",
    "try_again": "Try again",
    "try_another_view_or_clear_the_search": "Try another view or clear the search.",
    "unavailable": "Unavailable",
    "uncoded_item": "Uncoded item",
    "upload_claim": "Upload claim",
    "upload_empty_hint": "Upload a BPJS claim PDF to review denial risks and reimbursement opportunities.",
    "uploaded": "Uploaded ",
    "value_must_be_a_json_array": "Value must be a JSON array.",
    "verification_evidence_error": "Identify the source and page or record.",
    "verification_is_saved_for_this_review_and_confirmed_data_only_original_machine": "Verification is saved for this review and confirmed data only. Original machine assessments remain visible.",
    "verification_rationale_error": "Explain how the evidence resolves this check.",
    "verify_the_complete_history_before_resolving_this_check": "Verify the complete history before resolving this check.",
    "you": "You",
    "your_unsaved_bpjs_field_changes_will_be_lost": "Your unsaved BPJS field changes will be lost."
}
